import { Injectable, InjectionToken } from '@angular/core';

export const DEFAULT_SETTINGS_VALUE = new InjectionToken<string>('DEFAULT_SETTINGS_VALUE');
